//공고 모달 영역 타입
export enum JobPostModalAreaEnum {
  POSITION_LIST = 'POSITION_LIST', //모집 공고 영역
  JOBPOST_IMAGE_CONTENT = 'JOBPOST_IMAGE_CONTENT', //공고 내용 이미지 영역
  SIMILAR_POSITION_LIST = 'SIMILAR_POSITION_LIST', //비슷 한 공고 영역
}
